import { ChangeEvent } from "react";

export const unpack =
  <T>(cb: (v: T) => void) =>
  (e: ChangeEvent<any>) => {
    cb(e.target.value as T);
  };
